import * as React from "react"
import { Link } from "gatsby"
import Container from "../container/container"

import * as styles from "./resolve.module.scss"

import Markdown from "react-markdown"

const AboutResolve = props => {
  return (
    <div className={styles.resolve}>
      <Container>
        <div className={styles.resolve__wrap}>
          <h2>{props.data.ResolveHeading}</h2>
          <Markdown>{props.data.ResolveBody}</Markdown>
          <div className={`${styles.resolve__quote} d-flex align-items-center`}>
            <div className={styles.resolve__quote__image}>
              <div className={styles.resolve__quote__image__bg}></div>
              <img
                src={props.data.ResolveQuoteImage.publicURL}
                alt={props.data.ResolveQuote}
              />
            </div>
            <div className={styles.resolve__quote__content}>
              <p>{props.data.ResolveQuote}</p>
              <Link to="/case-studies/andrea-rainsford">Click here</Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default AboutResolve
